import { BLOCKS, INLINES, MARKS } from '@contentful/rich-text-types';

import ArrowLink from '../components/legos/ArrowLink';
import Button from '../components/legos/Button';
import Card from '../components/legos/Card';
import CustomText from '../components/legos/CustomText';
import Icon from '../components/legos/Icon';
import PictureWrapper from '../components/legos/PictureWrapper';
import Sym from '../components/legos/Sym';
import Video from '../components/legos/Video';

const customEmbeddedEntry = (node, key, h) => {
  const fields = node.data.target.fields;
  const type = node.data.target.sys.contentType.sys.id;

  if (type === 'arrowlink') {
    return h(ArrowLink, { key: key, props: { arrowLink: fields } });
  } else if (type === 'button') {
    return h(Button, { key: key, props: { button: fields } });
  } else if (type === 'card') {
    return h(Card, { key: key, props: { card: fields } });
  } else if (type === 'customText') {
    return h(CustomText, { key: key, props: { customText: fields } });
  } else if (type === 'icon') {
    return h(Icon, { key: key, props: { icon: fields } });
  } else if (type === 'image') {
    return h(PictureWrapper, {
      key: key,
      props: { image: fields, inline: false }
    });
  } else if (type === 'symbol') {
    return h(Sym, { key: key, props: { symbol: fields } });
  } else if (type === 'video') {
    return h(Video, { key: key, props: { video: fields } });
  } else {
    return '';
  }
};

const customEmbeddedInlineEntry = (node, key, h) => {
  const fields = node.data.target.fields;
  const type = node.data.target.sys.contentType.sys.id;

  if (type === 'arrowlink') {
    return h(ArrowLink, { key: key, props: { arrowLink: fields } });
  } else if (type === 'button') {
    return h(Button, { key: key, props: { button: fields } });
  } else if (type === 'card') {
    return h(Card, { key: key, props: { card: fields } });
  } else if (type === 'customText') {
    return h(CustomText, { key: key, props: { customText: fields } });
  } else if (type === 'icon') {
    return h(Icon, { key: key, props: { icon: fields } });
  } else if (type === 'image') {
    return h(PictureWrapper, {
      key: key,
      props: { image: fields, inline: true }
    });
  } else if (type === 'symbol') {
    return h(Sym, { key: key, props: { symbol: fields } });
  } else if (type === 'video') {
    return h(Video, { key: key, props: { video: fields } });
  } else {
    return '';
  }
};

const customCode = (node, key, h) => {
  return h('div', { domProps: { innerHTML: node[0] } });
};

export default {
  methods: {
    renderNodes() {
      return {
        [BLOCKS.EMBEDDED_ENTRY]: customEmbeddedEntry,
        [INLINES.EMBEDDED_ENTRY]: customEmbeddedInlineEntry
      };
    },
    renderMarks() {
      return {
        [MARKS.CODE]: customCode
      };
    }
  }
};
